/**
 * @ Author: Zhang Yujun
 * @ Create Time: 2025-01-23 19:59:23
 * @ Modified by: Zhang Yujun
 * @ Modified time: 2025-02-14 08:50:23
 * @ Description:
 */
import axios from '@/axios'
import CONFIG from '@/config'
import { getUserId } from '@/utils'
export * from '@/api/log'
export * from '@/api/pay'
export * from '@/api/personal'

/**
 * 添加用户播放记录
 * @param {object} obj
 * @returns
 */
export function addPlayRecord (obj) {
  return axios.post('ssg/playrecord/add-play-record', {
    appCode: CONFIG.APP_CODE,
    userId: getUserId(),
    role: 'guest',
    objectCodeType: obj.objectCodeType,
    objectCode: obj.objectCode,
    contentCode: obj.contentCode,
    position: obj.position,
    duration: obj.duration
  })
}
/**
 * 删除收藏
 * @param {object} obj
 * @returns
 */
export function favRemove (obj) {
  return axios.post('ssg/favorite/remove', {
    appCode: CONFIG.APP_CODE,
    userId: getUserId(),
    role: 'guest',
    type: obj.type,
    code: obj.code
  })
}
/**
 * 添加收藏
 * @param {object} obj
 * @returns
 */
export function favAdd (obj) {
  return axios.post('ssg/favorite/add', {
    appCode: CONFIG.APP_CODE,
    userId: getUserId(),
    role: 'guest',
    type: obj.type,
    code: obj.code,
    extra: obj.extra
  })
}
/**
 * 查询是否已经收藏
 * @param {object} obj
 * @returns
 */
export function isCollected (obj) {
  return axios.post('ssg/favorite/is-collected', {
    appCode: CONFIG.APP_CODE,
    userId: getUserId(),
    role: 'guest',
    type: obj.type,
    codes: obj.code
  })
}
/**
 * 播放地址解密
 * @param {string} playUrl 未解密播放地址
 * @returns
 */
export function getDecryptionPlayUrl (playUrl) {
  return axios.post('ssg/mp/play-url-decryption', {
    appCode: CONFIG.APP_CODE,
    playUrl: playUrl,
    type: 'aliCloud',
    effectiveTime: 60
  })
}
/**
 * 获取剧集详情
 * @param {string} code 剧集code
 * @returns
 */
export function getContentpkgDetails (code) {
  return axios.post('gsg/contentpkg/details', {
    appCode: CONFIG.APP_CODE,
    code
  })
}
/**
 * 获取内容详情
 * @param {string} code 内容code
 * @returns
 */
export function getContentDetails (code) {
  return axios.post('gsg/content/content-details', {
    appCode: CONFIG.APP_CODE,
    code,
    loadTag: false,
    userId: getUserId(),
    onlyOnline: true
  })
}
/**
 * 根据父标签查询所有子标签
 * @param {string} pCode 父标签code
 * @returns
 */
export function getTagListByPcode (pCode) {
  return axios.post('/gsg/tag/list-tag-by-pcode', {
    appCode: CONFIG.APP_CODE,
    pCode
  })
}
/**
 * 根据标签查询对应的所有剧集及子集列表
 * @param {string} tag 标签code
 * @returns
 */
export function getContentpkgsByTag (tagCode) {
  return axios.post('/gsg/contentpkg/list-contentpkg-by-tag', {
    appCode: CONFIG.APP_CODE,
    tagCode: tagCode,
    pageNumber: 1,
    pageSize: 9999
  })
}
/**
 * 剧集搜索-按标签
 * @param {Array} tagCode 剧集列表
 * @returns
 */
export function getContentpkgsPushByTag (tagList) {
  return axios.post('/gsg/contentpkg/search', {
    appCode: CONFIG.APP_CODE,
    userId: getUserId() || 'visitor',
    tagList: tagList,
    pageNumber: 1,
    pageSize: 9999,
    contentPkgType: 'wdj',
    orderBy: 'hot',
    needTagName: true
  })
}
/**
 * 获取页面配置详细信息
 * @param {string} code 页面编码
 * @param {boolean} showExtra 是否返回extra（门票门市价）
 * @returns
 */
export function getDetails ({ code, showExtra }) {
  return axios.post('gsg/page/details', {
    appCode: CONFIG.APP_CODE,
    code,
    showExtra
  })
}
/**
 * 搜索剧集
 * @param {string} name 搜索关键字
 * @returns
 */
export function searchContentpkg (name) {
  return axios.post('/gsg/contentpkg/search', {
    appCode: CONFIG.APP_CODE,
    userId: getUserId(),
    name: name,
    pageNumber: 1,
    pageSize: 9999,
    needTagName: true
  })
}
/**
 * 搜索内容
 * @param {string} name 搜索关键字
 * @returns
 */
export function searchContent (name) {
  return axios.post('/qgsp/content/search-content', {
    appCode: CONFIG.APP_CODE,
    userId: getUserId(),
    name: name,
    pageNumber: 1,
    pageSize: 9999,
    needTagName: true
  })
}
/**
 * 添加搜索记录
 * @param {string} contentPkgCode
 * @returns
 */
export function addSearchRecord (contentPkgCode) {
  return axios.post('/ssg/contentpkg-search-record/add', {
    appCode: CONFIG.APP_CODE,
    userId: getUserId(),
    contentPkgCode: contentPkgCode
  })
}
/**
 * 获取本人历史搜索记录
 * @returns
 */
export function getSearchRecord () {
  return axios.post('/ssg/contentpkg-search-record/list', {
    appCode: CONFIG.APP_CODE,
    userId: getUserId(),
    pageSize: 8,
    pageNumber: 1
  })
}
/**
 * 获取热门搜索记录
 * @returns
 */
export function getHotSearchRecord () {
  return axios.post('/gsg/contentlist/details', {
    appCode: CONFIG.APP_CODE,
    code: 'contentpkg_hot'
  })
}

/**
 * 获取用户微信openId
 * @param {string} params.code 用户授权的code
 * @param {string} params.type 类型
 */
export function getAccessToken (params) {
  return axios.post('ssg/wechat/get-access-token', {
    grantType: 'authorization_code',
    type: 'tqdwj',
    ...params
  })
}

export const cacheSet = (key, value) => {
  return axios.post('isg/cache/set', {
    appCode: CONFIG.APP_CODE,
    key,
    value,
    duration: 10
  })
}

export const getCommonConfig = code => {
  return axios.post('gsg/commonconfig/details', {
    appCode: CONFIG.APP_CODE,
    code: code
  })
}
/**
 * 获取电子书详细信息
 * @param {string} ebookCode 电子书编码
 * @returns
 */
export const getEbook = ebookCode => {
  return axios.post('ssg/ebook/details', {
    appCode: CONFIG.APP_CODE,
    ebookCode: ebookCode
  })
}
/**
 * 获取登录验证码.有ip黑名单及30秒请求限制
 * @param {string} phone 手机号
 * @returns
 */
export function sendMsg (phone) {
  return axios.post('qgsp/user/send-verifyCode', {
    appCode: CONFIG.APP_CODE,
    phone: phone,
    type: 'login'
  })
}
/**
 * 登陆校验接口
 * @param {object} obj
 * @returns
 */
export function login (obj) {
  return axios.post('qgsp/user/login-by-phone', {
    appCode: CONFIG.APP_CODE,
    phone: obj.phone,
    verifyCode: obj.verifyCode
  })
}
/**
 * 获取用户信息
 * @param {object} obj
 * @returns
 */
export function getUserInfo (userId) {
  return axios.post('qgsp/user/get-user', {
    appCode: CONFIG.APP_CODE,
    userId: userId || getUserId()
  })
}
